import {createStore, applyMiddleware } from 'redux';
import {composeWithDevTools } from 'redux-devtools-extension';
// import {createLogger } from 'redux-logger';
import promise from 'redux-promise-middleware';
import { createEpicMiddleware } from 'redux-observable';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import history from './routers/history';
import rootReducer from './reducers';
import allEpics from './epics';
import MixpanelMiddleware from 'redux-mixpanel-middleware'
import mixpanel from 'mixpanel-browser'
import {isProduction} from './utils/generalUtils'

// thunkMiddleware, // lets us dispatch() functions
// createLogger(), // neat middleware that logs actions
// promise(), // lets us dispatch() functions that return promises,

let middlewares = [thunkMiddleware, promise(), createEpicMiddleware(allEpics), routerMiddleware(history)];

if (isProduction()) {
   mixpanel.init("8646fbbe774a4969433d3f37f899fa23");
   const mixpanelMiddleware = new MixpanelMiddleware(mixpanel);
   middlewares = [...middlewares, mixpanelMiddleware];
}


const middleware = applyMiddleware(
   ...middlewares
);

export default createStore(rootReducer, composeWithDevTools(middleware));



// WEBPACK FOOTER //
// ./src/store.js